import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { CircularProgress, Typography, Box } from '@material-ui/core';

function SelectedStudentCountLabel({ count }) {
  return (
    <Box
      sx={{ position: 'relative', display: 'inline-flex' }}
      style={{ textAlign: 'end' }}
    >
      <span
        style={{
          fontSize: '15px',
          fontWeight: '500',
          position: 'relative',
          top: '0px',
          left: '-0.7em',
          color: '#3d3d2d',
        }}
      >
        Student selected
      </span>
      <br />
      <span
        style={{
          fontSize: '15px',
          fontWeight: '1000',
          marginRight: '0.7em',
          color: '#3BAEDB',
        }}
      >
        {count}
      </span>
    </Box>
  );
}

SelectedStudentCountLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

export default function CircularStatic({ count }) {
  return <SelectedStudentCountLabel count={count} />;
}
